import React from "react";

export const FocusedSessionsInputSection = ({
  formData,
  focusedSessions,
  registerForFocusedSessions,
  selectedFocusedSessions,
  focusedSessionAvailability,
  accompanyingPersonFee,
  onFocusedSessionsChange,
  onFocusedSessionSelect,
}) => {
  if (focusedSessions.length === 0) {
    return null;
  }

  const sessionsByDate = focusedSessions.reduce((groups, session) => {
    const dateGroup = session.sessionDate || session.dateGroup || "Other Sessions";
    if (!groups[dateGroup]) {
      groups[dateGroup] = [];
    }
    groups[dateGroup].push(session);
    return groups;
  }, {});
  const sortedDateGroups = Object.keys(sessionsByDate).sort((a, b) => {
    if (a === "Other Sessions") return 1;
    if (b === "Other Sessions") return -1;
    return a.localeCompare(b);
  });
  const hasPaidFocusedSession =
    formData.additionalFees &&
    formData.additionalFees.some(
      (fee) => fee.feeTypeId !== accompanyingPersonFee?.id && fee.paymentId
    );

  return (
    <div className="grid-item grid-item--full">
      <div>
        <label
          style={{
            display: "block",
            marginBottom: "10px",
            fontWeight: "500",
            color: "#000",
          }}
        >
          Register for Workshops
        </label>
        <div className="grid-item grid-item--radio" style={{ marginBottom: "10px" }}>
          <div className="radio-row" style={{ display: "flex", gap: "20px" }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <input
                type="radio"
                name="focusedSessions"
                value="Yes"
                checked={registerForFocusedSessions === "Yes"}
                onChange={(event) => onFocusedSessionsChange(event.target.value)}
                style={{ marginRight: "8px" }}
              />
              <span style={{ fontSize: "14px", color: "#000000" }}>Yes</span>
            </label>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <input
                type="radio"
                name="focusedSessions"
                value="No"
                checked={registerForFocusedSessions === "No"}
                onChange={(event) => onFocusedSessionsChange(event.target.value)}
                style={{ marginRight: "8px" }}
              />
              <span style={{ fontSize: "14px", color: "#000000" }}>No</span>
            </label>
          </div>
        </div>
        {registerForFocusedSessions === "Yes" && (
          <div>
            <div style={{ marginTop: "10px" }}>
              {focusedSessions.length > 0 ? (
                <div>
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000000",
                      marginBottom: "10px",
                      fontWeight: "500",
                    }}
                  >
                    Please select the Workshop you would like to attend:
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    {sortedDateGroups.map((dateGroup) => (
                      <div key={dateGroup} style={{ marginBottom: "10px" }}>
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#000000",
                            marginBottom: "8px",
                            paddingBottom: "4px",
                            borderBottom: "2px solid #e0e0e0",
                          }}
                        >
                          📅 {dateGroup}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                            paddingLeft: "10px",
                          }}
                        >
                          {sessionsByDate[dateGroup].map((session) => {
                            const isPaid =
                              formData.additionalFees &&
                              formData.additionalFees.some(
                                (fee) =>
                                  fee.feeTypeId === session.id && fee.paymentId
                              );
                            const isSelected = selectedFocusedSessions.includes(
                              session.id
                            );
                            const availability =
                              focusedSessionAvailability[session.id];
                            const availableSeats = Number(
                              availability?.availableSeats ??
                                availability?.available_seats ??
                                availability?.remainingSeats ??
                                session.availableSeats ??
                                session.available_seats ??
                                session.remainingSeats ??
                                0
                            );
                            const isFull =
                              (availability?.isFullyBooked ??
                                availability?.is_fully_booked ??
                                false) || availableSeats <= 0;
                            const disableSelection =
                              isPaid || (isFull && !isSelected);

                            return (
                              <label
                                key={session.id}
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  cursor: disableSelection
                                    ? "not-allowed"
                                    : "pointer",
                                  padding: isPaid ? "8px" : "4px",
                                  backgroundColor: isPaid
                                    ? "#f0f9ff"
                                    : isFull
                                    ? "#fff7e6"
                                    : "transparent",
                                  border: isPaid
                                    ? "2px solid #28a745"
                                    : isFull
                                    ? "2px solid #fd7e14"
                                    : "none",
                                  borderRadius: isPaid ? "6px" : "0",
                                  position: "relative",
                                }}
                                title={
                                  isPaid
                                    ? "⚠️ Payment completed - Cannot be unchecked or reversed"
                                    : isFull
                                    ? isSelected
                                      ? "⚠️ Session is full, but you may remove it from your selection"
                                      : "⚠️ Session is full - no seats available"
                                    : "Select this session"
                                }
                              >
                                {isPaid && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "-1px",
                                      right: "-1px",
                                      backgroundColor: "#28a745",
                                      color: "white",
                                      padding: "2px 8px",
                                      fontSize: "11px",
                                      fontWeight: "bold",
                                      borderTopRightRadius: "4px",
                                      borderBottomLeftRadius: "4px",
                                    }}
                                  >
                                    🔒 PAID
                                  </div>
                                )}
                                {isFull && !isPaid && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "-1px",
                                      right: "-1px",
                                      backgroundColor: "#fd7e14",
                                      color: "white",
                                      padding: "2px 8px",
                                      fontSize: "11px",
                                      fontWeight: "bold",
                                      borderTopRightRadius: "4px",
                                      borderBottomLeftRadius: "4px",
                                    }}
                                  >
                                    FULL
                                  </div>
                                )}

                                <input
                                  type="radio"
                                  name="focused-sessions"
                                  checked={selectedFocusedSessions?.[0] == session.id}
                                  onChange={() => onFocusedSessionSelect(session)}
                                  disabled={isPaid}
                                  style={{
                                    marginRight: "8px",
                                    marginTop: "2px",
                                    cursor: isPaid ? "not-allowed" : "pointer",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "14px",
                                    color: isPaid ? "#2e7d32" : "#000000",
                                    fontWeight: isPaid ? "500" : "normal",
                                    flex: 1,
                                  }}
                                >
                                  {session.value}
                                </span>
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontSize: "12px",
                                    color: isFull ? "#c2410c" : "#666",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {availableSeats > 0
                                    ? `${availableSeats} seats available`
                                    : "0 seats available"}
                                </span>
                              </label>
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                  {hasPaidFocusedSession && (
                    <div
                      style={{
                        marginTop: "12px",
                        padding: "10px",
                        backgroundColor: "#fff3cd",
                        border: "1px solid #ffc107",
                        borderRadius: "4px",
                        fontSize: "13px",
                        color: "#856404",
                      }}
                    >
                      <strong>⚠️ Important:</strong> Sessions marked as "PAID"
                      are locked because payment has been completed and cannot be
                      reversed. You can select new sessions which will require
                      additional payment.
                    </div>
                  )}
                </div>
              ) : (
                <p
                  style={{
                    fontSize: "13px",
                    color: "#666",
                    fontStyle: "italic",
                  }}
                >
                  No Workshops available.
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
